import React, { useEffect, useMemo, useState } from "react";



import {

  ArrowLeft,

  Plus,

  Search,

  X

} from "lucide-react";



import I from "../component/Icon";

import apiService from "../services/apiService";





const GET_ALL_USER_ROLES_API =

  "UserRole/getAllUserRoles?includeInActive=true";





const GET_ALL_MENUS_API =

  "Menu/getAllMenus?includeInActive=true";



const ADD_MENU_ROLE_MAPPING_API =

  "MenuRoleMapping/addMenuRoleMapping";



const GET_PAGINATED_MENU_ROLE_MAPPINGS_API =

  "MenuRoleMapping/getPaginatedMenuRoleMappings";



const DELETE_MENU_ROLE_MAPPING_API =

  "MenuRoleMapping/DeleteMenuRoleMapping";



const UPDATE_MENU_ROLE_MAPPING_API =

  "MenuRoleMapping/updateMenuRoleMapping";





const INITIAL = [];





const EMPTY = {

  role: "",

  menu: "",

  read: true,

  delete: true,

  edit: true,

  view: true,

  approve: true,

  active: true

};





const PERMISSIONS = [

  "read",

  "delete",

  "edit",

  "view",

  "approve",

  "active"

];





export default function MenuRoleMappingPage() {



  const [rowsData, setRowsData] = useState(INITIAL);



  const [search, setSearch] = useState("");



  // ============================

  // PAGINATION

  // ============================

  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize] = useState(10);



  const [modalOpen, setModalOpen] = useState(false);



  const [editing, setEditing] = useState(null);



  const [form, setForm] = useState(EMPTY);



  const [menuPermissions, setMenuPermissions] = useState([]);



  const [userRoles, setUserRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);



  const [menuLabels, setMenuLabels] = useState([]);



  const [menuOptions, setMenuOptions] = useState([]);



  // Prevent double click / duplicate Save-Update requests

  const [saving, setSaving] = useState(false);





  /* ========================================= */

  /* VIEW STATE */

  /* ========================================= */



  const [selectedView, setSelectedView] = useState(null);





  /* ========================================= */

  /* DELETE STATE */

  /* ========================================= */



  const [deleteTarget, setDeleteTarget] = useState(null);





  /* ========================================= */

  /* NOTIFICATION */

  /* ========================================= */



  const [notification, setNotification] = useState(null);



  const showNotification = (type, message) => {



    setNotification({

      type,

      message

    });



  };





  useEffect(() => {



    if (!notification) {

      return;

    }



    const timer = setTimeout(() => {



      setNotification(null);



    }, 3000);



    return () => clearTimeout(timer);



  }, [notification]);





  /* ========================================= */

  /* GET ALL USER ROLES - BACKEND API */

  /* ========================================= */



  const loadUserRoles = async () => {



    try {



      setRolesLoading(true);



      const response =

        await apiService.get(

          GET_ALL_USER_ROLES_API

        );



      const result =

        response.data;



      console.log(

        "Get All User Roles Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const roleResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

            ? output.result

            : Array.isArray(output?.Result)

              ? output.Result

              : Array.isArray(output?.data)

                ? output.data

                : Array.isArray(output?.Data)

                  ? output.Data

                  : [];



      const normalizedRoles =

        roleResult

          .map((role) => ({

            ...role,



            id:

              role?.id ??

              role?.Id ??

              role?.userRoleId ??

              role?.UserRoleId,



            name:

              role?.roleName ??

              role?.RoleName ??

              role?.name ??

              role?.Name ??

              "",

          }))

          .filter(

            (role) =>

              role.id &&

              role.name

          );



      setUserRoles(

        normalizedRoles

      );



    } catch (error) {



      console.error(

        "Get All User Roles API Error:",

        error

      );



      setUserRoles([]);



    } finally {



      setRolesLoading(false);



    }



  };





  useEffect(() => {



    loadUserRoles();



  }, []);





  /* ========================================= */

  /* GET ALL MENUS - BACKEND API */

  /* ========================================= */



  const loadMenuLabels = async () => {



    try {



      const response =

        await apiService.get(

          GET_ALL_MENUS_API

        );



      const result =

        response.data;



      console.log(

        "Get All Menus Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const menuResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

            ? output.result

            : Array.isArray(output?.Result)

              ? output.Result

              : Array.isArray(output?.data)

                ? output.data

                : Array.isArray(output?.Data)

                  ? output.Data

                  : [];



      const normalizedMenus =

        menuResult

          .map((menu) => ({

            id:

              menu?.id ??

              menu?.Id ??

              menu?.menuId ??

              menu?.MenuId,



            label:

              menu?.label ??

              menu?.Label ??

              "",

          }))

          .filter(

            (menu) =>

              menu.id &&

              String(menu.label).trim() !== ""

          );



      const labels =

        normalizedMenus.map(

          (menu) => menu.label

        );



      setMenuOptions(

        normalizedMenus

      );



      setMenuLabels(labels);



    } catch (error) {



      console.error(

        "Get All Menus API Error:",

        error

      );



      setMenuLabels([]);

      setMenuOptions([]);



    }



  };





  useEffect(() => {



    loadMenuLabels();



  }, []);





  /* ========================================= */

  /* GET PAGINATED MENU ROLE MAPPINGS - BACKEND API */

  /* ========================================= */



  const loadMenuRoleMappings = async () => {



    try {



      const requestBody = {

        Page: 1,

        PageSize: 1000,

        SearchTerm: "",

        SortDirection: "DESC",

        SortField: "Id"

      };



      console.log(

        "Get Paginated Menu Role Mappings Request:",

        requestBody

      );



      const response =

        await apiService.post(

          GET_PAGINATED_MENU_ROLE_MAPPINGS_API,

          requestBody

        );



      const result =

        response.data;



      console.log(

        "Get Paginated Menu Role Mappings Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const mappingResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

            ? output.result

            : Array.isArray(output?.Result)

              ? output.Result

              : Array.isArray(output?.data)

                ? output.data

                : Array.isArray(output?.Data)

                  ? output.Data

                  : [];



      const normalizedMappings =

        mappingResult.map((mapping) => {



          const readValue =

            mapping?.read ??

            mapping?.Read ??

            false;



          const deleteValue =

            mapping?.delete ??

            mapping?.Delete ??

            false;



          const editValue =

            mapping?.edit ??

            mapping?.Edit ??

            false;



          const viewValue =

            mapping?.view ??

            mapping?.View ??

            false;



          const approveValue =

            mapping?.approve ??

            mapping?.Approve ??

            false;



          const activeValue =

            mapping?.isActive ??

            mapping?.IsActive ??

            mapping?.active ??

            mapping?.Active ??

            false;



          const roleId =

            mapping?.roleId ??

            mapping?.RoleId ??

            mapping?.userRoleId ??

            mapping?.UserRoleId;



          const menuId =

            mapping?.menuId ??

            mapping?.MenuId;



          const roleFromBackend =

            mapping?.roleName ??

            mapping?.RoleName ??

            mapping?.role ??

            mapping?.Role ??

            "";



          const menuFromBackend =

            mapping?.menuName ??

            mapping?.MenuName ??

            mapping?.menu ??

            mapping?.Menu ??

            "";



          const roleFromList =

            userRoles.find(

              (role) =>

                Number(role.id) ===

                Number(roleId)

            )?.name ?? "";



          const menuFromList =

            menuOptions.find(

              (menu) =>

                Number(menu.id) ===

                Number(menuId)

            )?.label ?? "";



          return {

            ...mapping,



            id:

              mapping?.id ??

              mapping?.Id ??

              mapping?.menuRoleMappingId ??

              mapping?.MenuRoleMappingId,



            roleId:

              roleId,



            menuId:

              menuId,



            role:

              roleFromBackend ||

              roleFromList,



            menu:

              menuFromBackend ||

              menuFromList,



            read:

              readValue === true ||

              Number(readValue) === 1 ||

              String(readValue)

                .toLowerCase() === "true",



            delete:

              deleteValue === true ||

              Number(deleteValue) === 1 ||

              String(deleteValue)

                .toLowerCase() === "true",



            edit:

              editValue === true ||

              Number(editValue) === 1 ||

              String(editValue)

                .toLowerCase() === "true",



            view:

              viewValue === true ||

              Number(viewValue) === 1 ||

              String(viewValue)

                .toLowerCase() === "true",



            approve:

              approveValue === true ||

              Number(approveValue) === 1 ||

              String(approveValue)

                .toLowerCase() === "true",



            active:

              activeValue === true ||

              Number(activeValue) === 1 ||

              String(activeValue)

                .toLowerCase() === "true",

          };



        });



      setRowsData(

        normalizedMappings

      );



    } catch (error) {



      console.error(

        "Get Paginated Menu Role Mappings API Error:",

        error

      );



      setRowsData([]);



    }



  };





  useEffect(() => {



    if (

      userRoles.length > 0 &&

      menuOptions.length > 0

    ) {



      loadMenuRoleMappings();



    }



  }, [

    userRoles,

    menuOptions

  ]);





  const rows = useMemo(() => {



    const q = search.toLowerCase().trim();



    const allRows = rowsData;



    return !q

      ? allRows

      : allRows.filter((r) =>

        `${r.id} ${r.role} ${r.menu} ${r.active ? "active" : "inactive"}`

          .toLowerCase()

          .includes(q)

      );



  }, [rowsData, search]);



  const totalRecords = rows.length;



  const totalPages = Math.max(

    1,

    Math.ceil(totalRecords / pageSize)

  );



  const pageNumbers = Array.from(

    { length: totalPages },

    (_, index) => index + 1

  );



  const pageRecords = useMemo(() => {

    const startIndex = (currentPage - 1) * pageSize;

    const endIndex = startIndex + pageSize;



    return rows

      .slice(startIndex, endIndex)

      .map((row, index) => ({

        ...row,

        displayId:

          startIndex + index + 1

      }));

  }, [rows, currentPage, pageSize]);



  useEffect(() => {

    setCurrentPage(1);

  }, [search]);



  useEffect(() => {

    if (currentPage > totalPages) {

      setCurrentPage(totalPages);

    }

  }, [currentPage, totalPages]);





  /* ========================================= */

  /* ROLE WISE MENU PERMISSIONS */

  /* ========================================= */



  const getRoleMenuPermissions = (roleName) => {



    if (!roleName) {

      return [];

    }



    const roleMappings =

      rowsData.filter(

        (row) => row.role === roleName

      );



    return menuLabels.map((menuName) => {



      const existing =

        roleMappings.find(

          (row) => row.menu === menuName

        );



      return {

        menu: menuName,

        read:

          existing?.read ?? false,

        delete:

          existing?.delete ?? false,

        edit:

          existing?.edit ?? false,

        view:

          existing?.view ?? false,

        approve:

          existing?.approve ?? false,

        active:

          existing?.active ?? true

      };



    });



  };





  const handleRoleChange = (roleName) => {



    setForm((prev) => ({

      ...prev,

      role: roleName,

      menu: ""

    }));



    setMenuPermissions(

      getRoleMenuPermissions(roleName)

    );



  };





  const setMenuPermission = (

    menuName,

    permission,

    checked

  ) => {



    setMenuPermissions((prev) =>

      prev.map((menu) =>

        menu.menu === menuName

          ? {

            ...menu,

            [permission]: checked

          }

          : menu

      )

    );



  };





  /* ========================================= */

  /* ADD */

  /* ========================================= */



  const openAdd = () => {



    setEditing(null);



    setForm({

      ...EMPTY

    });



    setMenuPermissions([]);



    setNotification(null);



    setModalOpen(true);



  };





  /* ========================================= */

  /* EDIT */

  /* ========================================= */



  const openEdit = (row) => {



    setEditing(row);



    setForm({

      ...row

    });



    setMenuPermissions(

      getRoleMenuPermissions(row.role)

    );



    setNotification(null);



    setModalOpen(true);



  };





  /* ========================================= */

  /* VIEW */

  /* ========================================= */



  const openView = (row) => {



    setSelectedView(row);



  };





  const closeView = () => {



    setSelectedView(null);



  };





  /* ========================================= */

  /* SAVE / UPDATE */

  /* ========================================= */



  const hasAccessPermission = (permissionRow) =>

    Boolean(permissionRow.read) ||

    Boolean(permissionRow.delete) ||

    Boolean(permissionRow.edit) ||

    Boolean(permissionRow.view) ||

    Boolean(permissionRow.approve);





  const save = async (e) => {



    e.preventDefault();



    if (saving) {

      return;

    }



    if (!form.role) {

      showNotification("error", "Select Role.");

      return;

    }



    if (menuPermissions.length === 0) {

      showNotification("error", "Configure Menu Permissions.");

      return;

    }



    const selectedRole =

      userRoles.find(

        (role) =>

          role.name === form.role

      );



    const roleId =

      Number(

        editing?.roleId ??

        selectedRole?.id

      );



    if (

      !roleId ||

      Number.isNaN(roleId)

    ) {

      showNotification("error", "Invalid Role Id.");

      return;

    }



    setSaving(true);



    try {



      /*

        EDIT MODE

        Update must NEVER add a new mapping.

        Existing mapping => PUT

        Missing mapping  => skip

      */

      if (editing) {



        let updatedCount = 0;

        const processedKeys = new Set();



        for (const permissionRow of menuPermissions) {



          const selectedMenu =

            menuOptions.find(

              (menu) =>

                menu.label === permissionRow.menu

            );



          const menuId =

            Number(selectedMenu?.id);



          if (

            !menuId ||

            Number.isNaN(menuId)

          ) {

            throw new Error(

              `Invalid Menu Id for ${permissionRow.menu}`

            );

          }



          const mappingKey =

            `${roleId}:${menuId}`;



          if (processedKeys.has(mappingKey)) {

            continue;

          }



          processedKeys.add(mappingKey);



          const existingMapping =

            rowsData.find(

              (row) =>

                Number(row.roleId) === roleId &&

                Number(row.menuId) === menuId

            ) ??

            rowsData.find(

              (row) =>

                row.role === form.role &&

                row.menu === permissionRow.menu

            );



          /*

            CRITICAL FIX:

            In Update mode, if mapping does not exist,

            DO NOT call Add API.

          */

          if (!existingMapping) {

            console.log(

              "Update skipped - mapping does not exist:",

              {

                roleId,

                menuId,

                menu: permissionRow.menu

              }

            );

            continue;

          }



          const backendId =

            Number(

              existingMapping?.backendId ??

              existingMapping?.id

            );



          if (

            !backendId ||

            Number.isNaN(backendId)

          ) {

            throw new Error(

              `Invalid Menu Role Mapping Id for ${permissionRow.menu}`

            );

          }



          const updatePayload = {

            Id: backendId,

            roleId: roleId,

            menuId: menuId,

            read: Boolean(permissionRow.read),

            delete: Boolean(permissionRow.delete),

            edit: Boolean(permissionRow.edit),

            view: Boolean(permissionRow.view),

            approve: Boolean(permissionRow.approve),

            IsActive: Boolean(permissionRow.active),

          };



          console.log(

            "Update Menu Role Mapping Request:",

            updatePayload

          );



          const response =

            await apiService.put(

              UPDATE_MENU_ROLE_MAPPING_API,

              updatePayload

            );



          console.log(

            "Update Menu Role Mapping Status:",

            response.status

          );



          console.log(

            "Update Menu Role Mapping Response:",

            response.data

          );



          updatedCount += 1;

        }



        if (updatedCount === 0) {

          showNotification(

            "error",

            "No existing mapping found to update."

          );

          return;

        }



        await loadMenuRoleMappings();



        setModalOpen(false);

        setEditing(null);

        setMenuPermissions([]);



        showNotification(

          "success",

          "Menu role mapping updated successfully."

        );



        return;

      }





      /*

        ADD MODE

        Add can ONLY create missing mappings.

        Existing mapping => skip

        Missing mapping  => POST

      */

      const selectedMenuPermissions =

        menuPermissions.filter(

          (permissionRow) =>

            hasAccessPermission(permissionRow)

        );



      if (

        selectedMenuPermissions.length === 0

      ) {

        showNotification(

          "error",

          "Select at least one menu permission."

        );

        return;

      }



      const processedKeys = new Set();

      let addedCount = 0;

      const alreadyExistingMenus = [];



      for (

        const permissionRow

        of selectedMenuPermissions

      ) {



        const selectedMenu =

          menuOptions.find(

            (menu) =>

              menu.label === permissionRow.menu

          );



        const menuId =

          Number(selectedMenu?.id);



        if (

          !menuId ||

          Number.isNaN(menuId)

        ) {

          throw new Error(

            `Invalid Menu Id for ${permissionRow.menu}`

          );

        }



        const mappingKey =

          `${roleId}:${menuId}`;



        if (processedKeys.has(mappingKey)) {

          continue;

        }



        processedKeys.add(mappingKey);



        const existingMapping =

          rowsData.find(

            (row) =>

              Number(row.roleId) === roleId &&

              Number(row.menuId) === menuId

          ) ??

          rowsData.find(

            (row) =>

              row.role === form.role &&

              row.menu === permissionRow.menu

          );



        /*

          Save must not duplicate an existing role/menu mapping.

        */

        if (existingMapping) {

          alreadyExistingMenus.push(

            permissionRow.menu

          );



          console.log(

            "Add skipped - mapping already exists:",

            {

              roleId,

              menuId,

              menu: permissionRow.menu

            }

          );



          continue;

        }



        const addPayload = {

          roleId: roleId,

          menuId: menuId,

          read: Boolean(permissionRow.read),

          delete: Boolean(permissionRow.delete),

          edit: Boolean(permissionRow.edit),

          view: Boolean(permissionRow.view),

          approve: Boolean(permissionRow.approve),

          IsActive: Boolean(permissionRow.active),

        };



        console.log(

          "Add Menu Role Mapping Request:",

          addPayload

        );



        const response =

          await apiService.post(

            ADD_MENU_ROLE_MAPPING_API,

            addPayload

          );



        console.log(

          "Add Menu Role Mapping Status:",

          response.status

        );



        console.log(

          "Add Menu Role Mapping Response:",

          response.data

        );



        addedCount += 1;

      }



      if (addedCount === 0) {

        showNotification(

          "error",

          alreadyExistingMenus.length > 0

            ? "Selected menu mapping already exists for this role."

            : "No new menu mapping selected."

        );

        return;

      }



      await loadMenuRoleMappings();



      setSearch("");

      setCurrentPage(1);

      setModalOpen(false);

      setEditing(null);

      setMenuPermissions([]);



      showNotification(

        "success",

        "Menu role mapping added successfully."

      );



    } catch (error) {



      console.error(

        editing

          ? "Update Menu Role Mapping API Error:"

          : "Add Menu Role Mapping API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        (

          editing

            ? "Failed to update menu role mapping"

            : "Failed to add menu role mapping"

        )

      );



    } finally {



      setSaving(false);



    }



  };





  /* ========================================= */

  /* DELETE */

  /* ========================================= */



  const confirmDelete = async () => {



    if (!deleteTarget) {



      return;



    }





    try {



      const backendId =

        Number(

          deleteTarget?.backendId ??

          deleteTarget?.id

        );



      if (

        !backendId ||

        Number.isNaN(backendId)

      ) {



        showNotification(

          "error",

          "Invalid Menu Role Mapping Id."

        );



        return;



      }





      const response =

        await apiService.delete(

          `${DELETE_MENU_ROLE_MAPPING_API}/${backendId}`

        );



      console.log(

        "Delete Menu Role Mapping Status:",

        response.status

      );



      console.log(

        "Delete Menu Role Mapping Response:",

        response.data

      );





      setRowsData((prev) =>

        prev.filter(

          (row) =>

            Number(row.id) !==

            backendId

        )

      );





      setDeleteTarget(null);





      await loadMenuRoleMappings();





      showNotification(

        "success",

        "Menu role mapping deleted successfully."

      );





    } catch (error) {



      console.error(

        "Delete Menu Role Mapping API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to delete menu role mapping"

      );



    }



  };





  /* ===================================================== */

  /* VIEW PAGE */

  /* ===================================================== */



  if (selectedView) {



    return (



      <div className="um-page">



        <div className="um-card">





          {/* ========================================= */}

          {/* VIEW HEADER */}

          {/* ========================================= */}



          <div className="um-card-head">



            <h2>

              View Menu Role Mapping

            </h2>





            <button

              type="button"

              className="um-primary-btn"

              onClick={closeView}

            >



              <ArrowLeft size={17} />



              Back



            </button>



          </div>





          {/* ========================================= */}

          {/* VIEW DETAILS */}

          {/* ========================================= */}



          <div className="um-modal-body">



            <div className="um-grid-2">





              {/* ID */}



              <label className="um-field">



                <span>

                  Id

                </span>



                <input

                  type="text"

                  value={

                    selectedView.displayId ??

                    selectedView.id

                  }

                  readOnly

                />



              </label>





              {/* ROLE */}



              <label className="um-field">



                <span>

                  Role Name

                </span>



                <input

                  type="text"

                  value={selectedView.role}

                  readOnly

                />



              </label>





              {/* MENU */}



              <label className="um-field">



                <span>

                  Menu Name

                </span>



                <input

                  type="text"

                  value={selectedView.menu}

                  readOnly

                />



              </label>





              {/* READ */}



              <label className="um-field">



                <span>

                  Read

                </span>



                <input

                  type="text"

                  value={

                    selectedView.read

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





              {/* DELETE */}



              <label className="um-field">



                <span>

                  Delete

                </span>



                <input

                  type="text"

                  value={

                    selectedView.delete

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





              {/* EDIT */}



              <label className="um-field">



                <span>

                  Edit

                </span>



                <input

                  type="text"

                  value={

                    selectedView.edit

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





              {/* VIEW */}



              <label className="um-field">



                <span>

                  View

                </span>



                <input

                  type="text"

                  value={

                    selectedView.view

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





              {/* APPROVE */}



              <label className="um-field">



                <span>

                  Approve

                </span>



                <input

                  type="text"

                  value={

                    selectedView.approve

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





              {/* ACTIVE */}



              <label className="um-field">



                <span>

                  Active

                </span>



                <input

                  type="text"

                  value={

                    selectedView.active

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>





            </div>



          </div>





        </div>



      </div>



    );



  }





  /* ===================================================== */

  /* MAIN TABLE */

  /* ===================================================== */



  return (



    <div className="um-page menu-role-page">
      <style>{`
        .menu-role-page { min-width: 0; max-width: 100%; overflow-x: hidden; }
        .menu-role-page .um-card { min-width: 0; max-width: 100%; }
        .menu-role-page .um-table-wrap { max-width: 100%; overflow-x: auto; }
        .menu-role-page .pagination-footer {
          box-sizing: border-box; display: flex !important; flex-wrap: wrap !important;
          width: 100% !important; max-width: 100% !important; min-width: 0 !important;
          overflow: hidden !important;
        }
        .menu-role-page .pagination-bar {
          display: flex !important; align-items: center !important;
          flex: 1 1 280px !important; min-width: 0 !important;
          max-width: 100% !important; overflow: hidden !important;
          justify-content: flex-end !important; gap: 5px !important;
        }
        .menu-role-page .pagination-bar > button {
          flex: 0 0 auto !important; white-space: nowrap;
        }
        .menu-role-page .pagination-numbers {
          display: flex !important; align-items: center !important;
          flex: 0 1 auto !important; min-width: 0 !important; max-width: 100% !important;
          overflow-x: auto !important; overflow-y: hidden !important;
          white-space: nowrap !important; flex-wrap: nowrap !important;
          -webkit-overflow-scrolling: touch; scrollbar-width: thin;
          overscroll-behavior-x: contain;
        }
        .menu-role-page .pagination-numbers > button { flex: 0 0 auto !important; }
        @media (max-width: 768px) {
          .menu-role-page .pagination-footer {
            flex-direction: column !important; align-items: stretch !important; gap: 9px !important;
          }
          .menu-role-page .pagination-bar {
            flex: 0 0 auto !important; width: 100% !important;
            justify-content: space-between !important;
          }
          .menu-role-page .pagination-numbers { flex: 1 1 0 !important; max-width: none !important; }
          .menu-role-page .pagination-bar > button {
            min-width: 51px !important; padding: 0 7px !important; font-size: 10px !important;
          }
          .menu-role-page .pagination-numbers > button {
            min-width: 30px !important; padding: 0 7px !important;
          }
        }
      `}</style>






      {/* ========================================= */}

      {/* NOTIFICATION */}

      {/* ========================================= */}



      {notification && (



        <div

          style={{

            position: "fixed",

            top: "20px",

            right: "20px",

            zIndex: 99999,

            minWidth: "280px",

            maxWidth: "420px",

            padding: "12px 16px",

            borderRadius: "8px",

            backgroundColor:

              notification.type === "success"

                ? "#d1e7dd"

                : "#f8d7da",

            color:

              notification.type === "success"

                ? "#0f5132"

                : "#842029",

            border:

              notification.type === "success"

                ? "1px solid #badbcc"

                : "1px solid #f5c2c7",

            fontSize: "14px",

            fontWeight: 600,

            boxShadow: "0 4px 12px rgba(0,0,0,0.15)"

          }}

        >



          {notification.type === "success"

            ? "✓ "

            : "✕ "}



          {notification.message}



        </div>



      )}





      <div className="um-card">





        {/* ========================================= */}

        {/* TABLE HEADER */}

        {/* ========================================= */}



        <div className="um-card-head">



          <h2>

            Menu Role Mapping List

          </h2>





          <div className="um-head-actions">





            {/* ADD */}



            <button

              type="button"

              className="um-primary-btn"

              onClick={openAdd}

            >



              <Plus size={17} />



              Add New Menu Role Mapping



            </button>





            {/* SEARCH */}



            <label className="um-search">



              <Search size={17} />



              <input

                type="text"

                value={search}

                onChange={(e) =>

                  setSearch(e.target.value)

                }

                placeholder="Search..."

              />



            </label>





          </div>



        </div>





        {/* ========================================= */}

        {/* TABLE */}

        {/* ========================================= */}



        <div className="um-table-wrap">



          <table className="um-table">



            <thead>



              <tr>



                <th>Id</th>



                <th>Role Name</th>



                <th>Menu Name</th>



                <th>Read</th>



                <th>Delete</th>



                <th>Edit</th>



                <th>View</th>



                <th>Approve</th>



                <th>Active</th>



                <th>Actions</th>



              </tr>



            </thead>





            <tbody>



              {rows.length > 0 ? (



                pageRecords.map((row) => (



                  <tr key={row.id}>





                    <td>

                      {row.displayId}

                    </td>





                    <td>

                      {row.role}

                    </td>





                    <td>

                      {row.menu}

                    </td>





                    {PERMISSIONS.map((p) => (



                      <td key={p}>



                        {row[p]

                          ? "Yes"

                          : "No"}



                      </td>



                    ))}





                    {/* ========================================= */}

                    {/* ACTIONS - SAME AS EXAM */}

                    {/* ========================================= */}



                    <td>



                      <div className="ra">





                        {/* VIEW */}



                        <button

                          type="button"

                          className="btn btn-p btn-sm"

                          title="View"

                          onClick={() => openView(row)}

                        >



                          <I

                            n="eye"

                            s={11}

                            c="#fff"

                          />



                        </button>





                        {/* EDIT */}



                        <button

                          type="button"

                          className="btn btn-g btn-sm"

                          title="Edit"

                          onClick={() => openEdit(row)}

                        >



                          <I

                            n="edit"

                            s={11}

                          />



                        </button>





                        {/* DELETE */}



                        <button

                          type="button"

                          className="btn btn-d btn-sm"

                          title="Delete"

                          onClick={() =>

                            setDeleteTarget(row)

                          }

                        >



                          <I

                            n="trash"

                            s={11}

                          />



                        </button>





                      </div>



                    </td>





                  </tr>



                ))



              ) : (



                <tr>



                  <td

                    colSpan="10"

                    style={{

                      textAlign: "center",

                      padding: "25px"

                    }}

                  >



                    No records found



                  </td>



                </tr>



              )}



            </tbody>



          </table>



        </div>





        {/* ========================================= */}

        {/* PAGINATION */}

        {/* ========================================= */}



        {totalRecords > 0 && (

          <div

            style={{

              width: "100%",

              display: "flex",

              alignItems: "center",

              justifyContent: "space-between",

              gap: "16px",

              marginTop: "16px",

              padding: "12px 4px 4px",

              borderTop: "1px solid #eef2f7",

              flexWrap: "wrap"

            }}

          >
            <div className="pagination-count"

              style={{

                display: "flex",

                alignItems: "center",

                whiteSpace: "nowrap",

                fontSize: "11px",

                lineHeight: "16px",

                color: "var(--t3)"

              }}

            >

              Showing{" "}



              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)"

                }}

              >

                {(currentPage - 1) * pageSize + 1}

              </span>



              –



              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)"

                }}

              >

                {Math.min(

                  currentPage * pageSize,

                  totalRecords

                )}

              </span>



              {" "}of{" "}



              <span

                style={{

                  marginLeft: "4px",

                  fontWeight: 600,

                  color: "var(--t2)"

                }}

              >

                {totalRecords}

              </span>

            </div>





            {/* RIGHT SIDE - PAGINATION */}



            <div className="pagination-bar"

              style={{

                display: "flex",

                alignItems: "center",

                gap: "5px"

              }}

            >



              {/* BACK BUTTON */}



              <button

                type="button"

                disabled={currentPage === 1}

                onClick={() =>

                  setCurrentPage((previous) =>

                    Math.max(1, previous - 1)

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    currentPage === 1

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    currentPage === 1

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    currentPage === 1

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease"

                }}

              >

                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1

                  }}

                >

                  ‹

                </span>



                Back

              </button>





              {/* PAGE NUMBERS */}



              <div className="pagination-numbers"

                style={{

                  display: "flex",

                  alignItems: "center",

                  gap: "4px"

                }}

              >

                {pageNumbers.map((page) => (

                  <button

                    key={page}

                    type="button"

                    onClick={() =>

                      setCurrentPage(page)

                    }

                    style={{

                      height: "32px",

                      minWidth: "32px",

                      padding: "0 9px",

                      display: "inline-flex",

                      alignItems: "center",

                      justifyContent: "center",

                      border:

                        currentPage === page

                          ? "1px solid #2563eb"

                          : "1px solid #e2e8f0",

                      borderRadius: "6px",

                      background:

                        currentPage === page

                          ? "#2563eb"

                          : "#fff",

                      color:

                        currentPage === page

                          ? "#fff"

                          : "#475569",

                      fontSize: "11px",

                      fontWeight: 600,

                      cursor: "pointer",

                      transition: "all 0.15s ease"

                    }}

                  >

                    {page}

                  </button>

                ))}

              </div>





              {/* NEXT BUTTON */}



              <button

                type="button"

                disabled={currentPage >= totalPages}

                onClick={() =>

                  setCurrentPage((previous) =>

                    Math.min(

                      totalPages,

                      previous + 1

                    )

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    currentPage >= totalPages

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    currentPage >= totalPages

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    currentPage >= totalPages

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease"

                }}

              >

                Next



                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1

                  }}

                >

                  ›

                </span>

              </button>



            </div>



          </div>

        )}



      </div>





      {/* ===================================================== */}

      {/* ADD / EDIT MODAL */}

      {/* ===================================================== */}



      {modalOpen && (



        <div

          className="um-modal-backdrop"

          onMouseDown={() =>

            setModalOpen(false)

          }

        >



          <form

            className="um-modal um-modal-mapping"

            style={{

              width: "min(960px, 95vw)",

              maxWidth: "960px"

            }}

            onSubmit={save}

            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >





            {/* ========================================= */}

            {/* MODAL HEADER */}

            {/* ========================================= */}



            <div className="um-modal-head">



              <h3>

                {editing

                  ? "Update Menu Role Mapping"

                  : "Add Menu Role Mapping"}

              </h3>





              <button

                type="button"

                className="um-close-btn"

                onClick={() =>

                  setModalOpen(false)

                }

              >



                <X size={20} />



              </button>



            </div>





            {/* ========================================= */}

            {/* MODAL BODY */}

            {/* ========================================= */}



            <div className="um-modal-body">





              {/* ROLE */}



              <label className="um-field">



                <span>

                  Role

                </span>



                <select

                  value={form.role}

                  disabled={Boolean(editing)}

                  onChange={(e) =>

                    handleRoleChange(

                      e.target.value

                    )

                  }

                >



                  <option value="">

                    {rolesLoading

                      ? "Loading Roles..."

                      : "Select Role"}

                  </option>





                  {userRoles.map((role) => (



                    <option

                      key={role.id}

                      value={role.name}

                    >



                      {role.name}



                    </option>



                  ))}



                </select>



              </label>





              {/* ========================================= */}

              {/* ROLE SELECT केल्यावर PERMISSION TABLE */}

              {/* ========================================= */}



              {form.role && (



                <div

                  style={{

                    marginTop: "28px"

                  }}

                >



                  <div

                    style={{

                      fontSize: "16px",

                      fontWeight: 700,

                      color: "var(--t1)",

                      marginBottom: "18px"

                    }}

                  >

                    Configure Menu Permissions

                  </div>





                  <div

                    className="um-table-wrap"

                    style={{

                      maxHeight: "450px",

                      overflowY: "auto",

                      border: "1px solid var(--bd)",

                      borderRadius: "8px",

                      padding: "0px"

                    }}

                  >



                    <table

                      className="um-table"

                      style={{

                        margin: 0

                      }}

                    >



                      <thead

                        style={{

                          position: "sticky",

                          top: 0,

                          zIndex: 2

                        }}

                      >



                        <tr>



                          <th>

                            Menu Name

                          </th>



                          {PERMISSIONS.map(

                            (permission) => (



                              <th

                                key={permission}

                                style={{

                                  textAlign: "center"

                                }}

                              >

                                {permission

                                  .charAt(0)

                                  .toUpperCase() +

                                  permission.slice(1)}

                              </th>



                            )

                          )}



                        </tr>



                      </thead>





                      <tbody>



                        {menuPermissions.map(

                          (menuRow) => (



                            <tr

                              key={menuRow.menu}

                            >



                              <td>

                                {menuRow.menu}

                              </td>





                              {PERMISSIONS.map(

                                (permission) => (



                                  <td

                                    key={permission}

                                    style={{

                                      textAlign: "center"

                                    }}

                                  >



                                    <input

                                      type="checkbox"

                                      checked={

                                        Boolean(

                                          menuRow[

                                          permission

                                          ]

                                        )

                                      }

                                      onChange={(e) =>

                                        setMenuPermission(

                                          menuRow.menu,

                                          permission,

                                          e.target.checked

                                        )

                                      }

                                      style={{

                                        width: "17px",

                                        height: "17px",

                                        cursor: "pointer",

                                        accentColor: "#1684e8"

                                      }}

                                    />



                                  </td>



                                )

                              )}



                            </tr>



                          )

                        )}



                      </tbody>



                    </table>



                  </div>



                </div>



              )}





            </div>





            {/* ========================================= */}

            {/* MODAL FOOTER */}

            {/* ========================================= */}



            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"

                onClick={() =>

                  setModalOpen(false)

                }

              >



                Cancel



              </button>





              <button

                className="um-primary-btn"

                type="submit"

                disabled={!form.role || saving}

              >



                {saving

                  ? (editing ? "Updating..." : "Saving...")

                  : (editing ? "Update" : "Save")}



              </button>



            </div>





          </form>



        </div>



      )}





      {/* ===================================================== */}

      {/* DELETE POPUP */}

      {/* ===================================================== */}



      {deleteTarget && (



        <div

          className="um-modal-backdrop"

          onMouseDown={() =>

            setDeleteTarget(null)

          }

        >



          <div

            className="um-modal um-modal-role"

            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >





            {/* DELETE HEADER */}



            <div className="um-modal-head">



              <h3>

                Delete Menu Role Mapping

              </h3>





              <button

                type="button"

                className="um-close-btn"

                onClick={() =>

                  setDeleteTarget(null)

                }

              >



                <X size={20} />



              </button>



            </div>





            {/* DELETE BODY */}



            <div className="um-modal-body">



              <p>



                Are you sure you want to delete{" "}



                <strong>

                  {deleteTarget.role}

                </strong>



                {" → "}



                <strong>

                  {deleteTarget.menu}

                </strong>



                {" "}mapping?



              </p>



            </div>





            {/* DELETE FOOTER */}



            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"

                onClick={() =>

                  setDeleteTarget(null)

                }

              >



                Cancel



              </button>





              <button

                type="button"

                className="btn btn-d"

                onClick={confirmDelete}

              >



                Delete



              </button>



            </div>





          </div>



        </div>



      )}





    </div>



  );



}